import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import PopupPortal from 'apps/auth/components/common/Popup/PopupPortal';
import { Text } from 'apps/auth/components/common/Text/Text';
import FieldLongTitlePopup from 'apps/auth/components/form-multi/FieldLongTitlePopup';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { getTableTextColor, getTextPlusSubscriptionColor } from 'apps/auth/helpers/historyUtils';

import CheckTableRow from './CheckTableRow';

const FeeRateUnit = (props) => {
    const popupRef = useRef(null);
    const cheque = props.cheque;
    const [popups, setPopups] = useState('');

    const isUsaUser = () => {
        return props.userCountryId === USA;
    };

    const getPopupComponent = () => {
        if (popups === 'PAYSEND_PLUS_INFO') {
            return <FieldLongTitlePopup info={props.paysendPlusTitle} popupRef={popupRef} subscriptionType={cheque?.subscriptionType} />;
        } else {
            return <FieldLongTitlePopup info={props.exchangeRatePopupUsaCommentInfo} popupRef={popupRef} />;
        }
    };

    return (
        <>
            <Separator marginTop="16px" />
            <TableContainer>
                <CheckTableRow title={props.chequeFee} cheque={cheque}>
                    <Row flex align="center">
                        <Text color={cheque.subscriptionType === 'PAYSEND_PLUS' ? getTextPlusSubscriptionColor(cheque) : getTableTextColor(cheque)}>
                            {cheque.commission}
                        </Text>
                        {cheque.subscriptionType === 'PAYSEND_PLUS' && (
                            <DiskButton
                                size="small"
                                iconName="info-rounded"
                                iconColor={getTextPlusSubscriptionColor(cheque)}
                                type="button"
                                raised={false}
                                onClick={() => {
                                    setPopups('PAYSEND_PLUS_INFO');
                                    popupRef.current?.open();
                                }}
                            />
                        )}
                    </Row>
                </CheckTableRow>
                {cheque.exchangeRate && (
                    <CheckTableRow title={isUsaUser() ? props.chequeUsaFxRate : props.chequeFxRate} cheque={cheque}>
                        <Row flex align="center">
                            {cheque.exchangeRate}
                            {isUsaUser() && (
                                <DiskButton
                                    size="small"
                                    iconName="info-rounded"
                                    iconColor={getTableTextColor(cheque)}
                                    type="button"
                                    raised={false}
                                    onClick={() => {
                                        setPopups('USA_USER_INFO');
                                        popupRef.current?.open();
                                    }}
                                />
                            )}
                        </Row>
                    </CheckTableRow>
                )}
                {cheque.promoCode && cheque.subscriptionType !== 'PAYSEND_PLUS' && (
                    <CheckTableRow title={props.chequePromocodeFaild} cheque={cheque}>
                        {cheque.promoCode}
                    </CheckTableRow>
                )}
            </TableContainer>
            <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} as={PopupPortal} />
        </>
    );
};

const mapStateToProps = (state) => ({
    cheque: state.history.cheque.cheque,
    userCountryId: state.auth.countryId,
    chequePromocodeFaild: state.messages.pageMessages.chequePromocodeFaild,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    chequeUsaFxRate: state.messages.pageMessages.chequeUsaFxRate,
    exchangeRatePopupUsaCommentInfo: state.messages.pageMessages.exchangeRatePopupUsaCommentInfo,
    paysendPlusTitle: state.messages.pageMessages.paysendPlusTitle,
});

export default connect(mapStateToProps)(FeeRateUnit);
